import Box from '@mui/material/Box'
import { AnimatePresence, motion, Variants } from 'framer-motion'
import { observer } from 'mobx-react-lite'

const MotionBox = motion.create(Box)

const slideVariants: Variants = {
   enter: (custom: number) => ({
      x: custom > 0 ? '100%' : '-100%',
      opacity: 0,
      position: 'absolute' as const,
   }),
   center: {
      x: 0,
      opacity: 1,
      position: 'relative' as const,
   },
   exit: (custom: number) => ({
      x: custom < 0 ? '100%' : '-100%',
      opacity: 0,
      position: 'absolute' as const,
   }),
}


interface GapDialogChildSlideAnimationProps {
   mainComponent: React.ReactNode
   childComponent?: React.ReactNode
}

export default observer(function GapDialogChildSlideAnimation(props: GapDialogChildSlideAnimationProps) {

   return <AnimatePresence
      mode="wait"
      custom={!!props.childComponent ? 1 : -1}
      initial={false}
   >
      <MotionBox
         key={!!props.childComponent ? 'child' : 'main'}
         custom={!!props.childComponent ? 1 : -1}
         variants={slideVariants}
         initial="enter"
         animate="center"
         exit="exit"
         transition={{ duration: 0.35, ease: 'easeInOut' }}
         sx={{ width: '100%' }}
      >
         {!!props.childComponent ? props.childComponent : props.mainComponent}
      </MotionBox>
   </AnimatePresence>
})
